import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../tcn/ui-kit';
import { TCN } from '../../tcn/ui-kit/tokens';
import { formatInt } from '../shared/format';

/**
 * Module 1 — Header Strip
 * 4 mini stat cards aligned on mockup module1-performance.jsx:38-56:
 *   - Grid 1×4 (4 columns side-by-side, mobile + desktop)
 *   - Card padding 10px 8px (compact, NOT BigStat 32px)
 *   - Value 20/700/tabular-nums ON TOP, centered
 *   - Label 10/600/textMute uppercase 0.4 letter-spacing BELOW
 *   - Colors: Total=text, New=cyan, Active=green, Inactive=red
 */
const HeaderStrip = ({ data }) => {
  const { t } = useTranslation();
  const stats = [
    {
      label: t('tcn.m1.headerStrip.totalCreators', 'Total'),
      value: formatInt(data?.total_creators_mine),
      color: TCN.text,
    },
    {
      label: t('tcn.m1.headerStrip.newMtd', 'New'),
      value: formatInt(data?.total_new_creators_mtd),
      color: TCN.cyan,
    },
    {
      label: t('tcn.m1.headerStrip.active', 'Active'),
      value: formatInt(data?.total_active_creators),
      color: TCN.green,
    },
    {
      label: t('tcn.m1.headerStrip.inactive', 'Inactive'),
      value: formatInt(data?.total_inactive_creators),
      color: TCN.red,
    },
  ];

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 8,
      }}
    >
      {stats.map((s, i) => (
        <Card key={i} padded={false} style={{ padding: '10px 8px', textAlign: 'center' }}>
          <div
            style={{
              fontSize: 20,
              fontWeight: 700,
              color: s.color,
              fontVariantNumeric: 'tabular-nums',
              letterSpacing: '-0.4px',
              lineHeight: 1,
            }}
          >
            {s.value}
          </div>
          <div
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: TCN.textMute,
              letterSpacing: '0.4px',
              textTransform: 'uppercase',
              marginTop: 4,
            }}
          >
            {s.label}
          </div>
        </Card>
      ))}
    </div>
  );
};

export default HeaderStrip;
